(() => {
  if (window.collectionSwatchPreviewLoaded) return;
  window.collectionSwatchPreviewLoaded = true;
  const records = new WeakMap();
  const previews = new WeakMap();
  const selector = '[data-catalog-color], [data-model-color]';
  function choicesFor(control, sourceSelector) {
    if (!records.has(control)) {
      const source = control.querySelector(sourceSelector);
      records.set(control, source ? JSON.parse(source.textContent) : []);
    }
    return records.get(control);
  }
  function restore(card) {
    const state = previews.get(card);
    if (!state) return;
    for (const [name, value] of Object.entries(state.attributes)) {
      if (value === null) state.image.removeAttribute(name);
      else state.image.setAttribute(name, value);
    }
    if (state.secondary) state.secondary.hidden = state.secondaryHidden;
    previews.delete(card);
  }
  function preview(swatch) {
    const card = swatch.closest('.grid-product');
    const image = card?.querySelector('.product-image-frame img');
    if (!card || !image) return;
    const catalog = swatch.hasAttribute('data-catalog-color');
    const control = swatch.closest(catalog ? '[data-catalog-options]' : '[data-model-options]');
    if (!control) return;
    const choices = choicesFor(control, catalog ? '[data-catalog-variants]' : '[data-model-products]');
    let matches, current;
    if (catalog) {
      const index = Number(swatch.dataset.catalogIndex);
      const selected = [];
      control.querySelectorAll('[data-catalog-option]').forEach(input => {
        selected[Number(input.dataset.catalogOption)] = input.value;
      });
      control.querySelectorAll('[data-catalog-color][aria-pressed="true"]').forEach(button => {
        selected[Number(button.dataset.catalogIndex)] = button.dataset.catalogColor;
      });
      selected[index] = swatch.dataset.catalogColor;
      matches = choices.filter(choice => choice.options[index] === swatch.dataset.catalogColor);
      const exact = matches.filter(choice => choice.options.every((value, i) => value === selected[i]));
      current = exact.find(choice => choice.available) || exact[0];
    } else {
      matches = choices.filter(choice => choice.color === swatch.dataset.modelColor);
      const size = control.querySelector('[data-model-size]')?.value || '';
      const exact = matches.filter(choice => choice.size === size);
      current = exact.find(choice => choice.available) || exact[0];
    }
    current ||= matches.find(choice => choice.available) || matches[0];
    if (!current?.image) return;
    if (!previews.has(card)) {
      const secondary = card.querySelector('.grid-product__secondary-image');
      previews.set(card, {
        image,
        attributes: Object.fromEntries(['src', 'srcset', 'alt'].map(name => [name, image.getAttribute(name)])),
        secondary,
        secondaryHidden: secondary?.hidden
      });
    }
    image.removeAttribute('srcset');
    image.src = current.image;
    image.alt = current.alt || '';
    const secondary = card.querySelector('.grid-product__secondary-image');
    if (secondary) secondary.hidden = true;
  }
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    const swatch = event.target.closest(selector);
    if (swatch && !swatch.contains(event.relatedTarget)) preview(swatch);
  });
  document.addEventListener('pointerout', event => {
    const swatch = event.target.closest(selector);
    if (swatch && !swatch.contains(event.relatedTarget)) restore(swatch.closest('.grid-product'));
  });
  document.addEventListener('focusin', event => {
    const swatch = event.target.closest(selector);
    if (swatch) preview(swatch);
  });
  document.addEventListener('focusout', event => {
    const swatch = event.target.closest(selector);
    if (swatch && !swatch.contains(event.relatedTarget)) restore(swatch.closest('.grid-product'));
  });
  document.addEventListener('click', event => {
    const swatch = event.target.closest(selector);
    const card = swatch?.closest('.grid-product');
    if (card) previews.delete(card);
  });
})();
